import { IFetchUsersParams, IResponseFetchAllUsers } from '@interfaces'
import { objectToQueryString } from '@utils'
import { ApiClient } from 'src/api/axiosClient'
import { IResponseUploadThumbnail } from 'src/interfaces/blog'
import {
  ICreateEventPostValue,
  IEventPostParams,
  IGetEventPostsSuccessData,
  IResponseCreateEventPost,
  IResponseGetEventPostDetail,
} from 'src/interfaces/event-posts'

export const eventPostsAPI = {
  getListEventPosts: async (params: IEventPostParams) => {
    return await ApiClient.get<IGetEventPostsSuccessData>('/event-posts', {
      params: {
        ...params,
        sort: objectToQueryString(params.sort || {}) || undefined,
      },
    })
  },

  uploadMedia: async (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return await ApiClient.post<IResponseUploadThumbnail>(
      '/media/resize-resolution',
      formData
    )
  },

  getAuthorAdmins: async (params?: IFetchUsersParams) => {
    return await ApiClient.get<IResponseFetchAllUsers>('/users/list-admins', {
      params,
    })
  },

  getAuthorTeachers: async (params?: IFetchUsersParams) => {
    return await ApiClient.get<IResponseFetchAllUsers>('/teachers', {
      params,
    })
  },

  getCategories: async () => {
    return await ApiClient.get('/categories')
  },

  createEventPost: async (params: ICreateEventPostValue) => {
    return await ApiClient.post<IResponseCreateEventPost>('/event-posts', {
      title: params.title,
      content: params.content,
      eventId: params.eventId,
      eventDate: params.eventDate,
      published: params.published,
      slug: params.urlSlug,
      metaTitle: params.metaTitle,
      metaDescription: params.metaDescription,
      canonical: params.canonical,
      schemaMarkup: params.schemaMarkup,
      metaImage: params.metaImage,
      keywords: params.keywords,
      type: params.type,
      thumbnailId: params.thumbnailId,
      isDiscover: params.isDiscover,
      location: params.location,
      mediaIds: params.mediaIds,
    })
  },

  getEventPostDetail: async (eventId: string) => {
    return await ApiClient.get<IResponseGetEventPostDetail>(
      `/event-posts/${eventId}`
    )
  },

  updateEventPost: async (
    eventId: string | number,
    params: ICreateEventPostValue
  ) => {
    return await ApiClient.put<IResponseCreateEventPost>(
      `/event-posts/${eventId}`,
      {
        title: params.title,
        content: params.content,
        eventId: params.eventId,
        eventDate: params.eventDate,
        published: params.published,
        slug: params.urlSlug,
        metaTitle: params.metaTitle,
        metaDescription: params.metaDescription,
        canonical: params.canonical,
        schemaMarkup: params.schemaMarkup,
        metaImage: params.metaImage,
        keywords: params.keywords,
        type: params.type,
        thumbnailId: params.thumbnailId,
        isDiscover: params.isDiscover,
        location: params.location,
        mediaIds: params.mediaIds,
      }
    )
  },

  deleteEventPost: async (eventId: string | number) => {
    return await ApiClient.delete(`/event-posts/${eventId}`)
  },

  getRevenueEvent: async (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
  
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
  
    const queryString = params.toString();
    const url = `/weeztix-revenue/monthly-revenue${queryString ? `?${queryString}` : ''}`;
  
    return ApiClient.get(url);
  },

  getIncomeEvent: async (startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
  
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
  
    const queryString = params.toString();
    const url = `/weeztix-revenue/monthly-income${queryString ? `?${queryString}` : ''}`;
  
    return ApiClient.get(url);
  },

  getListTicket: async (guid?: string) => {
    const url = `/weeztix/shops/${guid}/tickets`
    return ApiClient.get(url);
  }
  
}
